module.exports = __webpack_public_path__ + "static/full13-268ba9edbc3978875fdb75f4e3d2e036.png";